import { JSX } from 'preact'
import { useTemplateTags } from '../useTemplateTags'
import { useFormContext } from '../Form/useFormContext'

interface Props {
  name: string
  label?: string
  value: string
  required?: boolean
  className?: string
}

export function Radio({ name, label, value, required, className }: Props): JSX.Element {
  const { template } = useTemplateTags()
  const { getValue, setValue } = useFormContext()
  const val = getValue(name)

  const handleChange = (e: Event) => {
    setValue(name, { value: [(e.target as HTMLInputElement).value] })
  }

  return (
    <label className={className}>
      <input
        required={required}
        type="radio"
        name={name}
        onChange={handleChange}
        value={value}
        checked={value === val}
      />
      <span dangerouslySetInnerHTML={{ __html: template(label) }} />
    </label>
  )
}
